import React from 'react';
import {useParams} from 'react-router-dom';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {ImportSyncedEntitiesModal} from './import-synced-entities.modal';

import type {CrmType} from 'src/openapi/admin/models/CrmType';

type Props = {
    targetLicenseId: number,
    crmType: CrmType,
    disabled?: boolean,
};

export const ImportSyncedEntities = ({targetLicenseId, crmType, disabled}: Props) => {
    const {shown, onClick, onClose} = useShown();
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? parseInt(queryParams.accountId) : -1;

    return (
        <>
            <Button variant="Type.PRIMARY" disabled={disabled} onClick={onClick}>
                Import Synced Entities to New License
            </Button>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: 700}}}>
                <ImportSyncedEntitiesModal {...{accountId, targetLicenseId, crmType, onClose}}/>
            </Dialog>
        </>
    );
};
